import { useEffect, useState } from "react";
import { getListaAuditoria } from "../../../../api/auditoria/auditoria";
import { Table, List, Label } from "semantic-ui-react";
import { PaginationTable } from "../../../../components/Common";
import { Segment, Input, Icon, Grid } from "semantic-ui-react";

export function AuditoriaList() {
  //   const { auth } = useAuth();
  const [historial, setHistorial] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [countPage, setCountPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [searchActive, setSearchActive] = useState("");
  const limitPagination = 10;

  const fetchHistorial = async (queryParam) => {
    try {
      const response = await getListaAuditoria(queryParam);
      if (response) {
        setHistorial(response.results);
        setCountPage(response.count);
        setLoading(false);
      } else {
        console.error("Error fetching audit history");
      }
    } catch (error) {
      console.error("Error fetching audit history:", error);
    }
  };

  useEffect(() => {
    const searchExistentes = sessionStorage.getItem("auditoria_search");
    if (searchExistentes) {
      setSearchActive(searchExistentes);
      fetchHistorial(`page=1&search=${searchExistentes}`);
    } else {
      fetchHistorial();
    }
  }, []);

  const onChangePage = (e, pageInfo) => {
    setActivePage(pageInfo.activePage);
    let queryParam = `page=${pageInfo.activePage.toString()}`;
    if (searchActive !== "") queryParam += `&search=${searchActive}`;
    fetchHistorial(queryParam);
  };

  const onSearch = (e) => {
    const value = e.target.value;
    setSearchActive(value);
    sessionStorage.setItem("auditoria_search", value);
    fetchHistorial(`page=1&search=${value}`);
    setActivePage(1);
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("es-ES", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const mostrarValor = (valor) =>
    valor === null || valor === undefined || valor === "" ? "—" : String(valor);

  const colorAccion = (accion) => {
    if (accion === "Crear") return "green";
    if (accion === "Eliminar") return "red";
    if (accion === "Actualizar") return "blue";
    return "grey";
  };

  const renderCambios = (item) => {
    const cambios = item.cambios || [];
    if (item.method !== "Actualizar") return "—";
    if (cambios.length === 0) return <span style={{ color: "#888" }}>Sin cambios</span>;
    return (
      <List size="small" className="lista-cambios-auditoria">
        {cambios.map((cambio, index) => (
          <List.Item key={index}>
            <b>{cambio.campo}:</b> {mostrarValor(cambio.anterior)}{" "}
            <Icon name="arrow right" size="small" /> {mostrarValor(cambio.nuevo)}
          </List.Item>
        ))}
      </List>
    );
  };

  return (
    <div>
      <h1>Historial de Auditoría</h1>
      <Grid as={Segment} className="segment_search">
        <Grid.Row>
          <Grid.Column computer={5} mobile={16} tablet={16}>
            <Input
              fluid
              icon={
                <Icon
                  name="search"
                  className="color_search"
                  inverted
                  circular
                />
              }
              className="input_search"
              inverted
              placeholder="Buscar por usuario, recurso, DNI, CUIT, campo..."
              value={searchActive}
              onChange={onSearch}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Table size="small" celled className="tabla-auditoria">
        <Table.Header className="color_header_table">
          <Table.Row>
            <Table.HeaderCell>Usuario</Table.HeaderCell>
            <Table.HeaderCell>Acción</Table.HeaderCell>
            <Table.HeaderCell>Recurso</Table.HeaderCell>
            <Table.HeaderCell>Identificador</Table.HeaderCell>
            <Table.HeaderCell>Registro</Table.HeaderCell>
            <Table.HeaderCell>Campos modificados</Table.HeaderCell>
            <Table.HeaderCell>Fecha</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body style={{ borderLeft: "1px solid white" }}>
          {historial.map((item) => (
            <Table.Row key={item.id}>
              <Table.Cell>{item.user_name}</Table.Cell>
              <Table.Cell>
                <Label size="small" color={colorAccion(item.method)}>
                  {item.method}
                </Label>
              </Table.Cell>
              <Table.Cell>{item.path}</Table.Cell>
              <Table.Cell>{mostrarValor(item.registro)}</Table.Cell>
              <Table.Cell>{mostrarValor(item.body)}</Table.Cell>
              <Table.Cell>{renderCambios(item)}</Table.Cell>
              <Table.Cell>{formatDate(item.timestamp)}</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
        <Table.Footer>
          <Table.Row>
            <Table.HeaderCell colSpan="10">
              <PaginationTable
                onChange={onChangePage}
                activePage={activePage}
                countPage={countPage}
                limitPagination={limitPagination}
              />
              Total de registros: {countPage}
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
    </div>
  );
}
